import React, { useState } from 'react';
import '../App.css';
import BlueBG from './img/blue-bg.png';
import PinkBG from './img/pink-bg.png';
import YellowBG from './img/yellow-bg.png';
import WhiteBG from './img/white-bg.png';

function Hero() {
  const [backgroundImage, setBackgroundImage] = useState(PinkBG);
  const [bulbImage, setBulbImage] = useState(`./pink-bulb.png`);

  const handleItemClick = (event, bgImage, bulbSrc) => {
    event.preventDefault();
    setBackgroundImage(bgImage);
    setBulbImage(bulbSrc);
  };

  return (
    <div className="hero bg-gray-100 flex items-center relative h-[90vh]"
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    > 
      <div className="absolute top-0 bg-[#0000004d] w-full h-full">
      </div>
      <div className="bulb absolute top-0 right-[8%] w-[fit-content]">
        <img src={bulbImage} className="w-[470px]" alt="Bulb" />
      </div>
      <div className="hero-container lg:container px-3 mx-auto z-10 relative">
        <div className="flex flex-wrap justify-between w-full hero-con-wrap">
          <div className="hero-left w-3/5">
            <h1 className="md:text-7xl sm:text-6xl text-5xl font-bold mb-4 font-syne text-white">Bring color <br />to your home</h1>
            <p className="sm:text-xl font-syne text-white">with CRYSTAL EURO Smart Bulb Essential (Color and White)</p>
            <div className='buy-btn'> 
              <button className='px-8 py-4 flex items-center gap-1 text-white bg-gradient-to-br from-[#674099] to-[#EB4F23] rounded-lg font-syne mt-8'>Buy Now 
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="white"/>
                  </svg>
                </span>
              </button>
            </div>
            
            <div className="flex justify-between items-center mt-20 hero-content">
              <div className="font-syne text-white">
                <p className='sm:text-3xl text-lg'>16 million</p>
                <p className='sm:text-xl'>colors</p>
              </div>
              <div className="font-syne text-white">
                <p className='sm:text-3xl text-lg'>2700 - 5000K</p>
                <p className='sm:text-xl'>color temperature</p>
              </div>
              <div className="font-syne text-white">
                <p className='sm:text-3xl text-lg'>15 scenarios</p>
                <p className='sm:text-xl'>preset</p>
              </div>
            </div>
          </div>
          <div className="hero-right w-2/5">
            <div className="lg:p-8 p-4 rounded-lg">
              <ul className="flex flex-col items-end z-10 relative gap-6 hero-light-btn">
                <li>
                  <a
                    href="#" className="flex flex-col items-center"
                    onClick={(event) => handleItemClick(event, YellowBG, `./yellow-bulb.png`)}
                  >
                    <p className="text-xs text-white">Sunset</p>
                    <img src={`./ellipse (1).png`} className="w-10" alt="Sunset" />
                  </a>
                </li>
                <li>
                  <a
                    href="#" className="flex flex-col items-center"
                    onClick={(event) => handleItemClick(event, BlueBG, `./blue-bulb.png`)}
                  >
                    <p className="text-xs text-white">Night</p>
                    <img src={`./ellipse (2).png`} className="w-10" alt="Night" />
                  </a>
                </li>
                <li>
                  <a
                    href="#" className="flex flex-col items-center"
                    onClick={(event) => handleItemClick(event, PinkBG, `./pink-bulb.png`)}
                  >
                    <p className="text-xs text-white">Romantic</p>
                    <img src={`./ellipse (3).png`} className="w-10" alt="Romantic" />
                  </a>
                </li>
                <li>
                  <a
                    href="#" className='flex flex-col items-center'
                    onClick={(event) => handleItemClick(event, WhiteBG, `./white-bulb.png`)}
                  >
                    <p className="text-xs text-white">Reading</p>
                    <img src={`./ellipse (4).png`} className="w-10" alt="Reading" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
